import styled from 'styled-components';

export const HoldingsSummaryCardStyles = styled.div`
	display: flex;
	gap: 0.5rem;
	padding: 1rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
	background: ${({ theme }) => theme.v3.colors.white[0]};

	> .stat {
		display: flex;
		flex-direction: column;
		flex: 1 1 0;
		min-width: 0;
	}

	.label {
		display: flex;
		align-items: center;
		gap: 0.5rem;
	}

	.value {
		font-size: 1.5rem;
		font-weight: 600;
		line-height: 2rem;
		color: ${({ theme }) => theme.v3.colors.dark[8]};

		/* AmountFormatted renders the amount inside its own Mantine <Text>, whose font-size
		   and weight would otherwise win over this block. Inheriting covers both it and the
		   bare dash it falls back to. */
		> * {
			font-size: inherit;
			font-weight: inherit;
			line-height: inherit;
			color: inherit;
		}
	}

	.dot {
		flex-shrink: 0;
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: ${({ theme }) => theme.v3.colors.gray[6]};

		&.value {
			background: ${({ theme }) => theme.v3.colors.teal[8]};
		}

		&.cost {
			background: ${({ theme }) => theme.v3.colors.blue[6]};
		}

		&.loan {
			background: ${({ theme }) => theme.v3.colors.red[6]};
		}
	}
`;
